import { NoddiDateFormats, noddiFormatDate } from './date';

/**
 * How every calendar tells history from what is ahead, on API dates ("2026-10-07"). API dates
 * sort as the days they name, so a string compare is a day compare with no time zone to shift it.
 */

const apiDate = (date: Date) => noddiFormatDate(date, NoddiDateFormats.API_DATE);

/** Today as an API date, local time like the dates calendars draw. */
export const todayApiDate = () => apiDate(new Date());

/** A day before `today`. */
export const isPastApiDate = (date: string, today: string) => date < today;

/**
 * Whether a month grid with past days hidden drops a week row: one that ended before today, in a
 * month with days left. A past month keeps every week, grayed, so stepping back never blanks it.
 * `weekEnd` is the row's last day in the grid; `monthEnd` the month's own last day.
 */
export const isPastWeekHidden = ({ weekEnd, monthEnd, today }: { weekEnd: string; monthEnd: string; today: string }) =>
  isPastApiDate(weekEnd, today) && !isPastApiDate(monthEnd, today);

/**
 * A row of days with past days hidden: today on. A row that is all past keeps every day, grayed,
 * so stepping back to last week shows it instead of nothing.
 */
export const datesFromToday = (dates: string[], today: string) => {
  const upcoming = dates.filter((date) => !isPastApiDate(date, today));
  return upcoming.length > 0 ? upcoming : dates;
};

/** Every API date from `from` through `to`, both included. */
export const apiDatesBetween = (from: string, to: string) => {
  const dates: string[] = [];
  // eslint-disable-next-line no-restricted-syntax -- a cursor stepping one day at a time
  for (let cursor = new Date(`${from}T12:00:00`); apiDate(cursor) <= to; cursor.setDate(cursor.getDate() + 1)) {
    dates.push(apiDate(cursor));
  }
  return dates;
};
